import IntersectionObserverManager from 'nespresso-library/src/utils/IntersectionObserverManager'
import { addClass, removeClass } from 'gaspard'

class ImgSrc {
    constructor (iom, el, getImgUrlMethod, sync) {
        if (!(getImgUrlMethod instanceof Function)) {
            throw new TypeError('You should provide a getImgUrl method')
        }
        this.iom = iom
        this.el = el
        this.getImgUrlMethod = getImgUrlMethod
        this.sync = sync
        addClass(el, 'g_imgSrc g_imgSrc_outOfScreen')
    }
    load (value, suffix) {
        removeClass(this.el, 'g_imgSrc_loaded')
        const src = value.url || this.getImgUrlMethod({ ...value, suffix })
        if (this.sync) {
            this.setBG(this.el, src)
        } else {
            const img = new Image()
            img.onload = () => this.setBG(this.el, src)
            img.onerror = () => {
                removeClass(this.el, 'g_imgSrc_outOfScreen')
                addClass(this.el, 'g_imgSrc_error')
                throw new Error(`Image ${src} cannot be loaded`)
            }
            this.iom.addItem({
                element: this.el,
                onViewportEnter: () => {
                    img.src = src
                }
            })
        }
    }
    setBG (el, src) {
        // rAF not force paint when user scroll
        requestAnimationFrame(() => {
            if (el.tagName === 'IMG') {
                el.src = src
            } else {
                el.style.backgroundImage = `url(${src})`
            }
            removeClass(el, 'g_imgSrc_outOfScreen')
            addClass(el, 'g_imgSrc_loaded')
        })
    }
}
export default class VueImgSrc {
    static install (Vue, options = {}) {
        const iom = new IntersectionObserverManager(options.iom)
        Vue.directive('ImgSrc', {
            bind (el, { value, modifiers }, { context }) {
                if (value && !value.disable) {
                    const bg = el.imgSrc = new ImgSrc(iom, el, value.getImgUrlMethod || options.getImgUrl || context.$landing.getImgUrl.bind(context.$landing), value.sync || modifiers.sync)
                    context.$watch('$imgSuffix', () => bg.load(value, value.suffix === false ? undefined : context.$imgSuffix), { immediate: true })
                }
            },
            update (el, { value, oldValue }, { context }) {
                if (value && !value.disable) {
                    const hasChanges = Object.entries(value).some(([key, val]) => oldValue[key] !== val)
                    if (hasChanges) {
                        el.imgSrc.load(value, value.suffix === false ? undefined : context.$imgSuffix)
                    }
                }
            },
            unbind (el, { value }) {
                if (value && !value.disable) {
                    iom.unobserve({
                        target: el
                    })
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/nespresso-components/media/VueImgSrc.js